import gql from 'graphql-tag';
import histroy from '../../history';
import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';
import showToaster from '../../helpers/showToaster';

export function addLocation(LocationName, coordinates, description) {

  let coordinatesError = '';
  if (!coordinates || coordinates == '') {
    showToaster({ messageId: 'addLocationError', toasterType: 'error' })
    coordinatesError = 'yes';
  }

  return async (dispatch, getState, { client }) => {
    const mutation = gql`
        mutation addLocation(
  				    $LocationName: String!,
              $coordinates: String!,
              $description: String!
            ) {
            addLocation(
              LocationName: $LocationName
              coordinates: $coordinates
              description: $description
            ){
              status
              errorMessage
            }
          }
        `;


    dispatch(setLoaderStart('AddLocation'));

    if (coordinatesError != '') {
      dispatch(setLoaderComplete('AddLocation'));
    }


    const { data } = await client.mutate({
      mutation,
      variables: {
        LocationName,
        coordinates,
        description
      },

    });

    dispatch(setLoaderComplete('AddLocation'));

    if (data && data.addLocation && data.addLocation.status === 200) {
      showToaster({ messageId: 'addLocationSuccess', toasterType: 'success' })
      histroy.push('/siteadmin/location');
    } else {
      showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data?.addLocation?.errorMessage })
    }
  }
}